import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { captureAttribution } from '@/utils/attribution'

/**
 * Records every page visit in the marketing attribution cookie (first touch once, last touch on each
 * tagged campaign visit), sent with sign-up. See utils/attribution.
 */
export const useAttributionCapture = (isEnabled: boolean) => {
  const { asPath, isReady } = useRouter()

  useEffect(() => {
    if (!isEnabled || !isReady) return
    captureAttribution()
  }, [isEnabled, isReady, asPath])
}
